export default IconMapHeart => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-map-heart" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M10 17.5l-1 -.5l-6 3v-13l6 -3l6 3l6 -3v7" />
  <path d="M9 4v13" />
  <path d="M15 7v4" />
  <path d="M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z" />
</svg>`;